<template>
  <div class="login-spacing">
    <h1>Passwort vergessen</h1>
    <div class="login-form-wrapper">

      <b-alert v-model="hasUnknownError" variant="danger">
        {{ unknownErrorMessage }}
      </b-alert>

      <b-alert v-model="hasError" variant="danger">
        {{ errorMessage }}
      </b-alert>

      <b-alert v-model="isSucceded" v-if="isSucceded" variant="success">
        {{ $t('forgotpassword.success') }}
      </b-alert>

      <validation-observer ref="observer" v-slot="{ passes }" v-else >
        <b-form @submit.prevent="passes(onSubmit)">

          <validation-provider vid="email" rules="required|email" v-slot="{ valid, errors, changed }">
            <b-form-group id="input-group-email" label="E-Mail" label-for="input-email">
              <b-form-input
                id="input-email"
                v-model="form.email"
                :state="onValidateField(valid, errors, changed)"
                type="email"
                placeholder="E-Mail angeben"
              ></b-form-input>
              <span class="input-live-feedback">{{ errors[0] }}</span>
            </b-form-group>
          </validation-provider>

          <b-button type="submit" variant="primary" class="w-100" disabled v-if="isSubmitting">
            <b-spinner small></b-spinner>
            Passwort zurücksetzen
          </b-button>
          <b-button type="submit" variant="primary" class="w-100" v-else>Passwort zurücksetzen</b-button>
        </b-form>
      </validation-observer>
      <p>
        <router-link to="/">Zurück zum Login</router-link>
      </p>
    </div>
  </div>
</template>

<script>
  import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import { errorHandler, validateField } from '@/helpers/formHelper.js'

  const getInitialData = () => ({
    form: {
      email: ''
    }
  })

  export default {
    components: {
      ValidationObserver,
      ValidationProvider
    },
    data: () => ({
      isSubmitting: false,
      isSucceded: false,
      hasUnknownError: false,
      unknownErrorMessage: '',
      hasError: false,
      errorMessage: '',
      ...getInitialData()
    }),
    methods: {
      onSubmit () {
        this.isSubmitting = true
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('user/FORGOT_PASSWORD', this.form).then(res => {
          const { errors } = res

          if (errors) {
            this.isSubmitting = false
            return errorHandler(this, errors)
          }

          this.isSucceded = true
          this.isSubmitting = false
          this.reset()
        }).catch(err => {
          this.isSubmitting = false
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      },
      reset () {
        Object.assign(this.$data, getInitialData())
        requestAnimationFrame(() => {
          this.$refs.observer.reset()
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login-spacing{
    margin-top: 7rem;
  }
  .login-form-wrapper{
    max-width: 320px;
    margin: 0 auto;
  }
</style>
